import { useCallback, useRef, useState } from 'react'
import { useCalendarStore } from '@/features/calendar/model/calendarStore'
import { useClinicalDocumentStore } from '@/features/clinicalDocuments/model/clinicalDocumentStore'
import { useExamStore } from '@/features/exams/model/examStore'
import { usePatientStore } from '@/features/patients/model/patientStore'
import { useSessionStore } from '@/features/session/model/sessionStore'

export const useMainDataRefresh = () => {
  const user = useSessionStore((state) => state.user)
  const fetchPatients = usePatientStore((state) => state.fetchPatients)
  const fetchExams = useExamStore((state) => state.fetchExams)
  const fetchEvents = useCalendarStore((state) => state.fetchEvents)
  const fetchDocuments = useClinicalDocumentStore((state) => state.fetchData)
  const runningRef = useRef(false)
  const [refreshing, setRefreshing] = useState(false)

  const refresh = useCallback(async () => {
    if (!user || runningRef.current) return
    runningRef.current = true
    setRefreshing(true)
    try {
      await Promise.all([fetchPatients(), fetchExams(), fetchEvents(), fetchDocuments()])
    } finally {
      runningRef.current = false
      setRefreshing(false)
    }
  }, [fetchDocuments, fetchEvents, fetchExams, fetchPatients, user])

  return {
    refresh,
    refreshing,
    enabled: Boolean(user),
  }
}
